module.exports = __webpack_public_path__ + "static/media/ONE.73e36574.svg";